var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNodeTree = function SvgNodeTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.12 2.6a.54.54 0 0 1 .54.54V5.3a.54.54 0 0 1-.54.54H5.04v1.08h2.7v-.54a.54.54 0 0 1 .54-.54h3.24a.54.54 0 0 1 .54.54v2.16a.54.54 0 0 1-.54.54H8.28a.54.54 0 0 1-.54-.54V8h-2.7v3.24h2.7v-.54a.54.54 0 0 1 .54-.54h3.24a.54.54 0 0 1 .54.54v2.16a.54.54 0 0 1-.54.54H8.28a.54.54 0 0 1-.54-.54v-.54H4.5a.54.54 0 0 1-.54-.54V5.84H2.88a.54.54 0 0 1-.54-.54V3.14a.54.54 0 0 1 .54-.54zm4.86 8.64H8.82v1.08h2.16zm0-4.32H8.82V8h2.16zm-5.4-3.24H3.42v1.08h2.16z"
  })));
};
export default SvgNodeTree;